import { publicApi } from "utils/util";
import { CourseList, CourseSearchParams } from "types/klass";

// MARK: 강의 검색 API
export const getCoursesSearchApi = async (params: CourseSearchParams) => {
  try {
    const response = await publicApi?.get("/class/public/courses/search", {
      params,
    });
    return response?.data.results.hits as CourseList[];
  } catch (error) {
    console.error("getCoursesSearchApi API error:", error);
    return [];
  }
};

// MARK: 무료 강의 목록 조회
export const getFreeCoursesApi = async (limit?: number) => {
  return getCoursesSearchApi({ free: true, ...(limit && { limit }) });
};

// MARK: 강의 연관 컨텐츠 조회 API(클래스/세미나)
export const getCourseRelatedContentsApi = async (params: {
  productId: string;
  contentType: "CLASS" | "SEMINAR";
}) => {
  try {
    const { data } = await publicApi?.get(
      `/market/products/${params.productId}/related-contents?contentType=${params.contentType}`,
    );
    return data.data;
  } catch (error) {
    console.error("getCourseRelatedContentsApi API error:", error);
    return [];
  }
};

// MARK: 강의 상품 조회
export const getCourse = async (params: { productId: string }) => {
  try {
    const { data } = await publicApi?.get(`/class/public/courses/product/${params.productId}`);
    return data;
  } catch (error) {
    console.error("getCourse API error:", error);
    return [];
  }
};
